import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useWhiteLabellingContext } from 'contexts/WhiteLabellingContext';
import { DownloadTray } from 'further-ui/components';
import { useBackgroundExports } from 'hooks/data/backgroundExports/useBackgroundExports';

const DownloadTrayContainer: React.FC = () => {
  const theme = useTheme();
  const { firm } = useWhiteLabellingContext();
  const {
    backgroundExports,
    downloadBackgroundExport,
    deleteBackgroundExport,
  } = useBackgroundExports();
  const exports = backgroundExports?.results ?? [];

  return (
    <DownloadTray
      borderColor={theme.palette.grey[300]}
      iconColor={firm?.whiteLabelConfig?.primaryColor}
      backgroundExports={exports}
      downloadBackgroundExport={(exportId: string) =>
        downloadBackgroundExport.mutate({ exportId })
      }
      deleteBackgroundExport={(exportId: string) =>
        deleteBackgroundExport.mutate({ exportId })
      }
      Heading={
        <Typography
          fontSize={18}
          fontWeight="bold"
          lineHeight={1.167}
          margin={0}
        >
          My downloads
        </Typography>
      }
    />
  );
};

export default DownloadTrayContainer;
